import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button } from 'react-bootstrap';
import '../styles/modalCss.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faX } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

const NewGameModal = ({ isOpen, onRequestClose, updateParentSelectedGame, fetchGamesNames }) => {
  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const [newGameName, setNewGameName] = useState(getCurrentDate());
  const [errorMsg, setErrorMsg] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    setErrorMsg('');
  }, [newGameName])

  const handleInputChange = (e) => {
    setNewGameName(e.target.value);
  };

  const handleSubmit = () => {
    if (newGameName === '') {
      setErrorMsg('יש להכניס שם של שחקן!');
      return
    }

    axios.post(`https://kaskas.pro/poker-stats-server/api/api/addNewGame`, { newGameName }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      let newGameResult = response.data.createNewGameResult
      if (newGameResult.status) {
        fetchGamesNames();
        updateParentSelectedGame(newGameName)
        onRequestClose();
        return;
      }
      setErrorMsg(newGameResult.message);

    }).catch(err => {
      setErrorMsg('Error');
      console.log(`Error fetching data:${err}`)
    })

  };

  const handleAfterOpen = () => {
    setNewGameName(getCurrentDate());
  };

  return (

    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      onAfterOpen={handleAfterOpen}
    >
      <div className='modalContainer'>
        <button className="closeButton" onClick={onRequestClose}>X</button>
        <h2 className='modalHeader'>יצירת משחק חדש:</h2>
        <input
          type="text"
          value={newGameName}
          onChange={handleInputChange}
          placeholder="הכניסו שם למשחק"
          className='modalInput'
        />
        {errorMsg ? <h3 className='errorMsg'>{errorMsg}</h3> : null}

        <div className='btnsContainer'>
          <Button className='modalbtns' variant='success' onClick={handleSubmit}>אישור  <FontAwesomeIcon icon={faCheck} /> </Button>
          <Button className='modalbtns' variant='danger' onClick={() => onRequestClose()}>ביטול  <FontAwesomeIcon icon={faX} /></Button>
        </div>
      </div>
    </Modal>
  );
};

export default NewGameModal;
